import { useRef, useState } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { H4 } from 'foundations-components/transitional/components/H4';
import { SafeHTML } from 'integrations-lib/components/SafeHTML';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthorizationStatusPopover = ({
  children,
  /**
   * The content of the footer
   */
  ctaButton,
  /**
   * Popover is hidden when disabled is true
   */
  disabled = false,
  /**
   * The content of the popover header
   */
  headingText,
  /**
   * The content of popover body
   */
  message,
  /**
   * If defined then popover is controlled by props
   */
  open
}) => {
  /**
   * Controls popover if `props.open` is undefined
   */
  const [stateOpen, setStateOpen] = useState(false);
  const popoverBodyRef = useRef(null);
  const hasContent = !!(headingText || message || ctaButton);
  const handleOpen = () => {
    if (open === false) return;
    setStateOpen(!disabled && hasContent);
  };
  const handleClose = () => {
    if (open) return;
    setStateOpen(false);
  };
  const handleToggle = () => {
    if (stateOpen) {
      handleClose();
    } else {
      handleOpen();
    }
  };
  const handleFocusLeave = () => {
    handleClose();
  };
  const handleOpenComplete = () => {
    var _popoverBodyRef$curre;
    (_popoverBodyRef$curre = popoverBodyRef.current) === null || _popoverBodyRef$curre === void 0 || _popoverBodyRef$curre.focus();
  };
  const content = Object.assign({}, !!headingText && {
    header: /*#__PURE__*/_jsx(H4, {
      children: headingText
    })
  }, {
    body: /*#__PURE__*/_jsx(View, {
      display: "block",
      tabIndex: -1,
      ref: popoverBodyRef,
      children: !!message && /*#__PURE__*/_jsx(SafeHTML, {
        html: message
      })
    })
  }, !!ctaButton && {
    footer: ctaButton
  });
  return /*#__PURE__*/_jsx(Popover, {
    use: "longform",
    onFocusLeave: handleFocusLeave,
    closeOnOutsideClick: true,
    onOpenComplete: handleOpenComplete,
    open: open !== null && open !== void 0 ? open : stateOpen,
    content: content,
    children: /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      onMouseDown: handleToggle,
      onMouseEnter: handleOpen,
      children: children
    })
  });
};